const SIGNATURE = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];

// FileReader e não Blob.arrayBuffer: o jsdom dos testes (Jest 27) não implementa o segundo.
const readHead = (file, bytes) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result));
    reader.onerror = () => reject(reader.error);
    reader.readAsArrayBuffer(file.slice(0, bytes));
});

/** Largura e altura do PNG lidas do IHDR (24 primeiros bytes); null quando não é PNG. */
export async function readPngSize(file) {
    const head = await readHead(file, 24);
    if (head.length < 24 || SIGNATURE.some((b, i) => head[i] !== b)) return null;
    if (String.fromCharCode(head[12], head[13], head[14], head[15]) !== "IHDR") return null;
    const view = new DataView(head.buffer, head.byteOffset, 24);
    return { width: view.getUint32(16), height: view.getUint32(20) };
}
